import { addDays } from 'date-fns';

export const calculateAge = (dateOfBirth: string): number => {
  const [day, month, year] = dateOfBirth.split('/').map(Number);
  const birthDate = new Date(year, month - 1, day);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

const formatDate = (timestamp: number): string => {
  // Validate timestamp
  if (!timestamp || isNaN(timestamp)) {
    return 'غير متوفر';
  }

  return new Date(timestamp).toLocaleString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

export const checkDateOverlap = (
  pilgrimCheckIn: number,
  pilgrimCheckOut: number,
  assignments: any[],
  addOffset: boolean = false
): { hasOverlap: boolean; conflictingAssignment?: any } => {
  console.log("Checking date overlap with:", {
    pilgrimCheckIn: new Date(pilgrimCheckIn).toISOString(),
    pilgrimCheckOut: new Date(pilgrimCheckOut).toISOString(),
    assignments: assignments.length,
    addOffset
  });
  
  // Convert timestamps to dates and reset time to midnight
  const checkIn = new Date(pilgrimCheckIn);
  checkIn.setHours(0, 0, 0, 0);
  
  const checkOut = new Date(pilgrimCheckOut);
  checkOut.setHours(0, 0, 0, 0);

  // Create temporary dates with offset for overlap checking only
  let checkInForComparison = new Date(checkIn);
  let checkOutForComparison = new Date(checkOut);
  
  // Add one day buffer if requested - this is only for comparison, not for saving
  if (addOffset) {
    checkInForComparison.setDate(checkInForComparison.getDate() + 1);
    checkOutForComparison.setDate(checkOutForComparison.getDate() - 1);
  }

  for (const assignment of assignments) {
    // Convert assignment dates to midnight
    let assignmentStart, assignmentEnd;
    
    // Handle both formats: timestamp and string DD/MM/YYYY
    if (typeof assignment.ci === 'string' && assignment.ci.includes('/')) {
      // Handle string format DD/MM/YYYY
      console.log("Processing string date:", assignment.ci);
      const [day, month, year] = assignment.ci.split('/').map(Number);
      assignmentStart = new Date(year, month - 1, day);
    } else {
      // Handle timestamp format
      console.log("Processing timestamp date:", assignment.ci);
      assignmentStart = new Date(assignment.ci);
    }
    assignmentStart.setHours(0, 0, 0, 0);
    
    if (typeof assignment.co === 'string' && assignment.co.includes('/')) {
      // Handle string format DD/MM/YYYY
      const [day, month, year] = assignment.co.split('/').map(Number);
      assignmentEnd = new Date(year, month - 1, day);
    } else {
      // Handle timestamp format
      assignmentEnd = new Date(assignment.co);
    }
    assignmentEnd.setHours(0, 0, 0, 0);

    console.log("Comparing dates:", {
      checkIn: checkInForComparison.toISOString(),
      checkOut: checkOutForComparison.toISOString(),
      assignmentStart: assignmentStart.toISOString(),
      assignmentEnd: assignmentEnd.toISOString()
    });

    // Check for overlap using the offset dates for comparison only
    const overlaps = !(
      checkOutForComparison <= assignmentStart || // New checkout is before or on existing check-in
      checkInForComparison >= assignmentEnd      // New check-in is after or on existing checkout
    );

    if (overlaps) {
      console.log("Overlap detected!");
      return { 
        hasOverlap: true, 
        conflictingAssignment: {
          checkIn: assignmentStart.toISOString(),
          checkOut: assignmentEnd.toISOString()
        }
      };
    }
  }
  
  console.log("No overlaps found");
  return { hasOverlap: false };
};